import { render, staticRenderFns } from "./AppEngWrittenAssessment.vue?vue&type=template&id=36690b60&scoped=true"
import script from "./AppEngWrittenAssessment.vue?vue&type=script&lang=ts"
export * from "./AppEngWrittenAssessment.vue?vue&type=script&lang=ts"
import style0 from "./AppEngWrittenAssessment.vue?vue&type=style&index=0&id=36690b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36690b60",
  null
  
)

export default component.exports